"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSyncStatusOverlay = exports.StyledAttributeTagsViewCell = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importStar(require("styled-components"));
const syncPulse = (0, styled_components_1.keyframes) `
  from {
    opacity: 0.32;
  }

  to {
    opacity: 0.58;
  }
`;
exports.StyledAttributeTagsViewCell = styled_components_1.default.div `
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 0;
`;
exports.StyledSyncStatusOverlay = styled_components_1.default.div `
  position: absolute;
  inset: 0 -10px;
  z-index: 1;
  pointer-events: none;
  mix-blend-mode: multiply;

  &.syncing {
    background: ${ui_components_1.baseColors.gray200};
    animation: ${syncPulse} 0.9s ease-in-out infinite alternate;
  }

  &.synced {
    background: ${ui_components_1.baseColors.primaryGreen400};
    opacity: 0.22;
  }

  &.failed {
    background: ${ui_components_1.baseColors.red300};
    opacity: 0.24;
  }
`;
